import type { OpsTemplateField } from '../../../types/ops';
import { fromLocalDateTimeInput } from '../../../utils/localDateTimeInput';

/**
 * Normalizes register form values for submission.
 * Converts DATE_TIME fields from local input string (or date representation)
 * to epoch milliseconds.
 */
export function normalizeRecordValues(
  rawValues: Record<string, unknown> | null | undefined,
  fields: OpsTemplateField[],
): Record<string, unknown> {
  if (!rawValues) return {};
  const normalized: Record<string, unknown> = { ...rawValues };
  for (const field of fields) {
    if (field.type === 'DATE_TIME' && field.key in normalized) {
      const v = normalized[field.key];
      if (v !== null && v !== undefined && v !== '') {
        const ms = fromLocalDateTimeInput(v);
        if (ms !== null) {
          normalized[field.key] = ms;
        }
      }
    }
  }
  return normalized;
}
